
































































































































import { Component, Vue, Prop, Watch, PropSync } from "vue-property-decorator";
import { DataTableHeader, DataOptions } from "vuetify";
import { ListModel } from "../../shared/models/listModel";
import { CurrencyEnum } from "@/shared/models/enums.type";
import AccomodationUnitTypeDrawer from "@/components/accomodation-unit-type/AccomodationUnitTypeDrawer.vue";
import {
  AvailabilitySearchResult,
  Rate,
  SelectedAvailability,
} from "@/shared/models/availability";
import MoreLessSelect from "@/components/misc/MoreLessSelect.vue";
import NumericPicker from "@/components/misc/NumericPicker.vue";
import MobileFilterModal from "@/components/misc/MobileFilterModal.vue";
import NoData from "@/components/misc/NoData.vue";
import { FinancialSettingsType } from "@/store/modules/financial";
import { Action, Getter } from "vuex-class";
import { SearchRestrictionsModel } from "../reservation-form/types";
import { AvailabilitySearchPrefillModel } from "./types";

@Component({
  components: {
    AccomodationUnitTypeDrawer,
    MoreLessSelect,
    NumericPicker,
    MobileFilterModal,
    NoData,
  },
})
export default class AvailabilitySearchResultsMobile extends Vue {
  isDetailsOpen = false;
  detailsItem: AvailabilitySearchResult | null = null;
  filterModalOpen = false;
  tooltipOpen = false;

  @PropSync("openFilter") internalOpenFilter?: boolean;
  @Prop() items?: ListModel<AvailabilitySearchResult>;
  @Prop({ default: null }) searchRestrictions?: SearchRestrictionsModel | null;
  @Prop() loading?: boolean;
  @Prop() takenAvailabilities?: SelectedAvailability[];
  @Prop() freedAvailabilities?: SelectedAvailability[];
  @Prop() selectedAvailabilities?: SelectedAvailability[];
  @Prop() confirmSelectionLabel?: string;
  @Prop({ default: true }) isGlobalSearch?: boolean;

  get filterPrefill() {
    return {
      period: undefined,
      numberOfAdults: 2,
      numberOfChildren: 0,
      numberOfUnits: 1,
      numberOfBedrooms: 0,
      numberOfBathrooms: 0,
      childrenAges: undefined,
    } as AvailabilitySearchPrefillModel;
  }

  @Getter("financial/settings") storedSettings?: FinancialSettingsType;
  @Action("financial/refreshModel") refreshSettings?: () => Promise<void>;

  created() {
    if (!this.storedSettings && this.refreshSettings) {
      this.refreshSettings();
    }
  }

  get _selectedAvailabilities() {
    return this.selectedAvailabilities;
  }
  set _selectedAvailabilities(val) {
    this.$emit("update:selectedAvailabilities", val);
  }

  gotSelected = false;

  @Watch("selectedAvailabilities")
  selectedAvailabilitiesChanged() {
    this.gotSelected = true;
  }

  ratePlan(item: AvailabilitySearchResult) {
    return item.rates[0];
  }

  ratePlans(item: AvailabilitySearchResult) {
    return item.rates;
  }

  availableUnits(item: AvailabilitySearchResult) {
    return item.numberOfAvailableUnits + "/" + item.totalNumberOfUnits;
  }

  selectAccommodation(unit: AvailabilitySearchResult, event: MouseEvent) {
    this.showTooltip(unit, event);
    this.selectAvailability(1, unit, this.ratePlan(unit));
  }

  get sheet() {
    if (this.selectedAvailabilities) {
      return this.selectedAvailabilities?.length > 0;
    }
    return false;
  }

  get missingUnits() {
    if (!this.searchRestrictions) {
      return 0;
    }
    return Math.max(
      (this.searchRestrictions.numberOfUnits || 0) -
        (this.selectedAvailabilities?.length || 0),
      0
    );
  }

  get missingOccupancy() {
    if (!this.searchRestrictions) {
      return 0;
    }
    return Math.max(
      (this.searchRestrictions.numberOfAdults || 0) +
        (this.searchRestrictions.numberOfChildren || 0) -
        this.maxOccupancy,
      0
    );
  }

  get maxOccupancy() {
    return (
      this.selectedAvailabilities?.reduce(
        (sum, x) => sum + (x.numberOfOccupants || 0),
        0
      ) || 0
    );
  }

  tooltip: any = null;
  get tooltipKey() {
    return this.tooltip?.accomodationUnitTypeId ?? 1;
  }
  get tootipPosition() {
    return { x: this.tooltip?.positionX ?? 0, y: this.tooltip?.positionY ?? 0 };
  }

  showTooltip(item: any, event: MouseEvent) {
    this.tooltip = {
      propertyName: item.propertyName,
      positionX: event.clientX,
      positionY: event.clientY,
    };
    setTimeout(() => {
      this.tooltip = null;
    }, 1500);
  }

  confirmSelection() {
    this.$emit("confirmSelection");
  }

  currencyEnum = CurrencyEnum;

  expanded: AvailabilitySearchResult[] = [];

  options: DataOptions = {
    page: 1,
    itemsPerPage: 15,
    sortBy: [],
    sortDesc: [],
    groupBy: [],
    groupDesc: [],
    multiSort: false,
    mustSort: false,
  };

  @Watch("options")
  optionsWatch() {
    this.$emit("paginationChange", this.options);
  }

  headers: DataTableHeader[] = [
    {
      text: "Accomodation unit",
      value: "propertyName",
    },
    {
      text: "Available units",
      value: "numberOfAvailableUnits",
    },
    {
      text: "Price range",
      value: "price",
    },
    {
      text: "Actions",
      value: "actions",
      align: "end",
    },
  ];
  get translatedHeaders() {
    if (this.$vuetify.breakpoint.mdAndUp || this.$vuetify.breakpoint.xsOnly) {
      return this.headers.map((x) => ({ ...x, text: this.$t(x.text) }));
    } else {
      return this.headers
        .filter((x) => x.value == "propertyName" || x.value == "actions")
        .map((x) => ({ ...x, text: this.$t(x.text) }));
    }
  }

  updateFilter(filters: any) {
    this.$emit("filterUpdated", filters);
  }

  isExpanded(item: AvailabilitySearchResult) {
    return this.expanded.some((x) => x == item);
  }

  getNumberOfAvailableUnits(item: AvailabilitySearchResult) {
    const timesSelected =
      this.selectedAvailabilities?.filter(
        (x) => x.accomodationUnitTypeId == item.accomodationUnitTypeId
      ).length || 0;
    const timesTaken =
      this.takenAvailabilities?.filter(
        (x) => x.accomodationUnitTypeId == item.accomodationUnitTypeId
      ).length || 0;
    const timesFreedUp =
      this.freedAvailabilities?.filter(
        (x) => x.accomodationUnitTypeId == item.accomodationUnitTypeId
      ).length || 0;

    return Math.max(
      item.numberOfAvailableUnits - timesSelected - timesTaken + timesFreedUp,
      0
    );
  }

  getPrice(item: AvailabilitySearchResult, rate: Rate) {
    return rate.totalPrice;
  }

  getPriceRange(item: AvailabilitySearchResult) {
    const ratesPrices = item.rates.map((r) => r.totalPrice);
    const min = Math.min(...ratesPrices);

    const max = Math.max(...ratesPrices);

    const currencyId =
      item && item.rates && item.rates.length > 0
        ? item.rates[0].currencyId
        : this.storedSettings?.workingCurrency.id ?? this.currencyEnum.EUR; // Default EUR, but it should find tenant working currency
    const currencyISO3 = this.currencyEnum[currencyId];

    if (min !== max) {
      return (
        this.$n(min, {
          maximumFractionDigits: "2",
          minimumFractionDigits: "2",
        }) +
        "-" +
        this.$n(max, {
          style: "currency",
          currency: currencyISO3,
          display: "code",
        })
      );
    } else {
      return this.$n(min, {
        style: "currency",
        currency: currencyISO3,
        display: "code",
      });
    }
  }

  getAveragePricePerNight(item: AvailabilitySearchResult, rate: Rate) {
    const price = this.getPrice(item, rate);
    return price / item.numberOfNights;
  }

  // selection of availabilities
  availabilitySelectionChange(
    wantedAmount: number,
    item: AvailabilitySearchResult,
    rate: Rate
  ) {
    const timesAlreadySelected = this.getNumberOfTimesAvailabilityIsSelected(
      item,
      rate
    );

    if (typeof wantedAmount != "number" || wantedAmount < 0) {
      wantedAmount = 0;
    }

    if (timesAlreadySelected > wantedAmount) {
      this.deselectAvailability(
        timesAlreadySelected - wantedAmount,
        item,
        rate
      );
    } else if (timesAlreadySelected < wantedAmount) {
      this.selectAvailability(wantedAmount - timesAlreadySelected, item, rate);
    }
  }

  selectAvailability(
    amount: number,
    item: AvailabilitySearchResult,
    rate: Rate
  ) {
    if (!this._selectedAvailabilities) {
      return;
    }

    const temp = this._selectedAvailabilities.slice();
    for (let i = 0; i < amount; i++) {
      temp.push({
        accomodationUnitTypeId: item.accomodationUnitTypeId,
        ratePlansAccomodationUnitTypeId: rate.ratePlansAccomodationUnitTypeId,
        ratePlanId: rate.ratePlanId,
        numberOfOccupants: rate.maxPersons,
      });
    }
    this._selectedAvailabilities = temp.slice();
  }
  deselectAvailability(
    amount: number,
    item: AvailabilitySearchResult,
    rate: Rate
  ) {
    if (!this._selectedAvailabilities) {
      return;
    }

    const temp = this._selectedAvailabilities.slice();

    for (let i = 0; i < amount; i++) {
      const index = SelectedAvailability.GetFirstIndexInArray(temp, item, rate);

      if (index != -1) {
        temp.splice(index, 1);
      }
    }

    this._selectedAvailabilities = temp.slice();
  }

  getNumberOfTimesAvailabilityIsSelected(
    item: AvailabilitySearchResult,
    rate: Rate
  ) {
    if (!this._selectedAvailabilities) {
      return 0;
    }

    return SelectedAvailability.GetCountInArray(
      this._selectedAvailabilities,
      item,
      rate
    );
  }

  // details form opening
  openItemDetails(item: AvailabilitySearchResult) {
    this.detailsItem = item;
    this.isDetailsOpen = true;
  }

  // details form opening
  getMaxOccupancy(item: AvailabilitySearchResult) {
    if (item.extraBedsCapacity)
      return `${item.baseBedsCapacity}+${item.extraBedsCapacity}`;
    return `${item.baseBedsCapacity}`;
  }

  // functions for applying css classes representing selected availabilities
  highlightSelectedItem(item: AvailabilitySearchResult) {
    const toReturn = { "is-selected-highlight": false, item: false };

    if (this.expanded.indexOf(item) != -1) {
      toReturn.item = true;
    }

    if (!this._selectedAvailabilities) {
      return toReturn;
    }

    for (const rate of item.rates) {
      if (
        SelectedAvailability.GetFirstIndexInArray(
          this._selectedAvailabilities,
          item,
          rate
        ) != -1
      ) {
        toReturn["is-selected-highlight"] = true;
        return toReturn;
      }
    }

    return toReturn;
  }

  highlightSelectedRate(item: AvailabilitySearchResult, rate: Rate) {
    if (!this._selectedAvailabilities) {
      return false;
    }

    if (
      SelectedAvailability.GetFirstIndexInArray(
        this._selectedAvailabilities,
        item,
        rate
      ) != -1
    ) {
      return true;
    }

    return false;
  }

  highlightSelectedOption(item: AvailabilitySearchResult, rate: Rate) {
    if (!this._selectedAvailabilities) {
      return false;
    }

    return (
      SelectedAvailability.GetFirstIndexInArray(
        this._selectedAvailabilities,
        item,
        rate
      ) != -1
    );
  }

  getRateColorClasses(index: number) {
    const evenOdd = index % 2 == 0 ? "rate-even" : "rate-odd";
    const lightDark = this.$vuetify.theme.dark ? "theme--dark" : "theme--light";
    return evenOdd + " " + lightDark;
  }

  getRateName(rate: Rate) {
    const paxSuffix =
      rate.minPersons === rate.maxPersons
        ? `${rate.minPersons} pax`
        : `${rate.minPersons}-${rate.maxPersons} pax`;
    const losSuffix =
      rate.maxStay === 0
        ? `${rate.minStay}+ LOS`
        : rate.minStay === rate.maxStay
        ? `${rate.minStay} LOS`
        : `${rate.minStay}-${rate.maxStay} LOS`;

    return `${rate.ratePlanName}, ${paxSuffix}, ${losSuffix}`;
  }

  closingFilterModal() {
    if (this.items?.count == 0) {
      this.internalOpenFilter = false;
    }
  }
}
